import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import EmailImapSmtpConfigUpdate from './EmailImapSmtpConfig/EmailImapSmtpConfigUpdate';
import EmailKnownImapConfigUpdate from './EmailKnownImapConfig/EmailKnownImapConfigUpdate';
import EmailGoogleOauthConfig from './EmailGoogleOauthConfig/EmailGoogleOauthConfigUpdate';
import EmailMicrosoftOauthConfig from './EmailMicrosoftOauthConfig/EmailOauthConfigUpdate';

class EmailConfigUpdate extends PureComponent {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    emailConfigId: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
      access_provider: PropTypes.string,
      sender_name: PropTypes.string,
      reply_to_email: PropTypes.string,
      signature: PropTypes.string,
      total_number_of_emails_per_day: PropTypes.number,
      delay_between_each_email_sent: PropTypes.number,
      is_primary: PropTypes.bool,
      imap_config: PropTypes.shape({
        username: PropTypes.string,
        password: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
      smtp_config: PropTypes.shape({
        username: PropTypes.string,
        password: PropTypes.string,
        host: PropTypes.string,
        port: PropTypes.number,
        is_ssl_enabled: PropTypes.bool,
      }),
    }).isRequired,
    closeMenu: PropTypes.func,
  };

  static defaultProps = {
    closeMenu: () => {},
  };

  render() {
    const {
      initialValues,
      initialValues: { access_type: accessType },
      ...props
    } = this.props;

    return (
      <React.Fragment>
        {accessType === 'imap_smtp' &&
          <EmailImapSmtpConfigUpdate
            className="float-right"
            initialValues={initialValues}
            {...props}
          />
        }

        {/* LEGACY */}
        {accessType === 'imap_outlook' &&
          <EmailKnownImapConfigUpdate
            className="float-right"
            initialValues={initialValues}
            {...props}
          />
        }

        {accessType === 'google_oauth' &&
          <EmailGoogleOauthConfig
            className="float-right"
            initialValues={initialValues}
            {...props}
          />
        }
        {accessType === 'microsoft_oauth' &&
          <EmailMicrosoftOauthConfig
            className="float-right"
            initialValues={initialValues}
            {...props}
          />
        }
      </React.Fragment>
    );
  }
}

export default compose(
  connect(
    state => ({
      config: state.config,
    }),
    { },
  ),
  withNamespaces('common'),
)(EmailConfigUpdate);
